export default __webpack_public_path__ + "static/bottom-shadow-8757fa4c15975ae15d4d5c1998565486.png";